export default {
    restrict: 'A',
    template: '',
    link: function link() {}
};


//////////////////
// WEBPACK FOOTER
// ./app/js/portal/directives/wizardSidebarAdditional.js
// module id = 1320
// module chunks = 0